import { api } from "./authService";

// A definitive-grades confirmation is identified by learner + class + semester.
// The classId must therefore travel with every entry-scoped call.
const classParams = (classId) =>
  classId === undefined || classId === null ? {} : { params: { classId } };

const revisorService = {
  getDashboard: async () => {
    const response = await api.get("/revisor/dashboard");
    return response.data;
  },

  getReviews: async () => {
    const response = await api.get("/revisor/reviews");
    return response.data;
  },

  getDetail: async (learnerId, semesterId, classId) => {
    const response = await api.get(
      `/revisor/reviews/${learnerId}/${semesterId}`,
      classParams(classId),
    );
    return response.data;
  },

  markChecked: async (learnerId, semesterId, classId) => {
    const response = await api.post(
      `/revisor/reviews/${learnerId}/${semesterId}/check`,
      null,
      classParams(classId),
    );
    return response.data;
  },

  // Takes a check back - the entry returns to "awaiting check" for everyone.
  uncheck: async (learnerId, semesterId, classId) => {
    const response = await api.post(
      `/revisor/reviews/${learnerId}/${semesterId}/uncheck`,
      null,
      classParams(classId),
    );
    return response.data;
  },

  finalize: async (learnerId, semesterId, classId) => {
    const response = await api.post(
      `/revisor/reviews/${learnerId}/${semesterId}/finalize`,
      null,
      classParams(classId),
    );
    return response.data;
  },

  reject: async (learnerId, semesterId, reason, classId) => {
    const response = await api.post(
      `/revisor/reviews/${learnerId}/${semesterId}/reject`,
      { reason },
      classParams(classId),
    );
    return response.data;
  },

  deleteReviewEntry: async (learnerId, semesterId, classId) => {
    const response = await api.delete(
      `/revisor/reviews/${learnerId}/${semesterId}`,
      classParams(classId),
    );
    return response.data;
  },

  resetAllRevisions: async () => {
    const response = await api.post("/revisor/reviews/reset-all");
    return response.data;
  },
};

export default revisorService;
